export default __webpack_public_path__ + "static/media/Sofia-Very-Light.cab9609d.otf";